import DataPoint from './DataPoint';
import UnmappedRecordStatus from '../enums/UnmappedRecordStatus';

export interface UnmappedRecordInterface {
  dataPoints: Array<DataPoint>,
  recordId: string,
  traitsStudyProcedureKey: number,
  traitsStudyProcedureId: string,
  traitsStudyId: string,
  patientProcedureKey: number,
  procedureName: string,
  subjectId: string,
}

export default class UnmappedRecord {
  dataPoints: Array<DataPoint>;

  recordId: string;

  traitsStudyProcedureKey: number;

  traitsStudyProcedureId: string;

  traitsStudyId: string;

  patientProcedureKey: number;

  procedureName: string;

  status: UnmappedRecordStatus;

  eSourceStudyId?: string;

  subjectId: string;

  constructor(unmappedRecordInterface: UnmappedRecordInterface) {
    this.dataPoints = unmappedRecordInterface.dataPoints;
    this.recordId = unmappedRecordInterface.recordId;
    this.traitsStudyProcedureKey = unmappedRecordInterface.traitsStudyProcedureKey;
    this.traitsStudyProcedureId = unmappedRecordInterface.traitsStudyProcedureId;
    this.traitsStudyId = unmappedRecordInterface.traitsStudyId;
    this.subjectId = unmappedRecordInterface.subjectId;
    this.patientProcedureKey = unmappedRecordInterface.patientProcedureKey;
    this.procedureName = unmappedRecordInterface.procedureName;
    this.status = UnmappedRecordStatus.UNMAPPED;
    this.eSourceStudyId = unmappedRecordInterface.dataPoints.length > 0
      ? unmappedRecordInterface.dataPoints[0]?.study_id
      : undefined;
  }
}
